<template>
    <p v-if="!isSupport()" class="text-attentions" v-html="message_body">
    </p>
</template>

<script>
export default {
name: "UnSupportMessage",
    props: [
        'message_body'
    ],
    data() {
        return {
        }
    },
    methods: {
        isSupport() {
            var ua = window.navigator.userAgent.toLowerCase();

            if(ua.indexOf("windows nt") !== -1) {
                // Windows
                return true;
            } else if(ua.indexOf("android") !== -1) {
                // Android
                return true;
            } else if(ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1) {
                // iOS
                return true;
            } else if(ua.indexOf("mac os x") !== -1) {
                if ('ontouchend' in document){
                    // タッチイベント対応しているのでiPad
                    return true;
                }

                // Mac
                return false;
            } else {
                // それ以外のOS(BlackBerry等)
                return false;
            }
        }
    }
}
</script>

<style scoped>

</style>
